import { render, staticRenderFns } from "./ItemGrid.vue?vue&type=template&id=654af30f&scoped=true"
import script from "./ItemGrid.vue?vue&type=script&lang=js"
export * from "./ItemGrid.vue?vue&type=script&lang=js"
import style0 from "./ItemGrid.vue?vue&type=style&index=0&id=654af30f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654af30f",
  null
  
)

export default component.exports